<template>
    <div class="form-block">
        <h3 class="d-none d-lg-block">Location</h3>
        <div class="fields-container social">
            <md-checkbox
                v-model="online"
                @change="
                    basedIn = [];
                    acKey++;
                "
                >Online community</md-checkbox
            >
            <div class="wrap-set-location">
                <div
                    v-for="(location, index) in basedIn"
                    :key="index"
                    class="location d-inline-flex mr-2"
                >
                    <span>
                        <strong>{{ location.city }}</strong> -
                        <em>{{ getCountryName(location.country) }}</em>
                    </span>
                    <i
                        class="material-icons close-btn"
                        @click="() => removeLocation(index)"
                        >close</i
                    >
                </div>
            </div>
            <md-field :class="error ? 'md-invalid' : ''" v-show="!online">
                <input
                    class="md-input mt-0"
                    ref="maps-autocomplete"
                    v-model="location"
                />
                <span v-if="!basedIn.length" class="md-helper-text"
                    >*Required</span
                >
                <span class="md-error">At least one location is required</span>
            </md-field>
            <md-autocomplete
                v-show="online"
                :key="acKey"
                v-model="selectedCountry"
                :md-options="countries.map(({ text }) => text)"
                @md-selected="addCountry"
            >
                <label>Search country</label>
                <span v-if="!basedIn.length" class="md-helper-text"
                    >*Required</span
                >
                <span class="md-error">At least one country is required</span>
            </md-autocomplete>
        </div>
    </div>
</template>
<script>
import { getCountryName, isoCountries } from "@/services/utils";

export default {
    name: "Location",
    data: () => ({
        location: "",
        online: false,
        selectedCountry: "",
        acKey: 0,
    }),
    props: ["value", "error"],
    computed: {
        basedIn: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        countries() {
            return Object.entries(isoCountries)
                .map((el) => ({
                    country: el[0],
                    city: "Online",
                    text: el[1],
                }))
                .filter(
                    (c) => !this.basedIn.find(({ text }) => text === c.text)
                );
        },
    },
    methods: {
        addCountry(val) {
            this.basedIn.push(this.countries.find((el) => el.text === val));
            setTimeout(() => {
                this.selectedCountry = "";
                this.acKey++;
            }, 1);
        },
        getCountryName,
        removeLocation(index) {
            this.basedIn.splice(index, 1);
        },
        getPlace() {
            const place = this.autocomplete.getPlace();
            const ac = place.address_components;
            const city = ac[0].long_name;
            let country;
            ac.forEach((el) => {
                if (el.types.includes("country")) {
                    country = el.short_name;
                    return;
                }
            });
            this.basedIn.push({
                city: city,
                country: country,
            });
            this.location = "";
        },
    },
    mounted() {
        if (this.basedIn[0] && this.basedIn[0].city === "Online") {
            this.online = true;
        }
        this.autocomplete = new google.maps.places.Autocomplete(
            this.$refs["maps-autocomplete"],
            {
                types: ["(cities)"],
            }
        );
        this.autocomplete.addListener("place_changed", this.getPlace);
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_common.scss";
.location {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px;
    border-radius: 10px;
    height: 38px;
    padding-left: 15px;
    padding-right: 5px;
    border-radius: 30px;
    background-color: whitesmoke;
    i {
        margin-left: 10px;
    }
    .form-text {
        margin-top: 0 !important;
    }
}
</style>

